<div class="search-and-sort-container">

  @if (showSearch) {
    <div class="search-container">
      <mat-form-field appearance="outline">
        <mat-label>Application Tracking ID</mat-label>
        <input matInput type="textbox" [(ngModel)]="appId">
      </mat-form-field>
      <button (click)="searchPlans()" type="submit" mat-raised-button color="primary">Search</button>
      <button (click)="clearSearch()" type="submit" mat-stroked-button color="accent">Clear</button>
    </div>
  }

  <div class="sort-container">
    <mat-form-field appearance="outline">
      <mat-label class="filter-label">Filter</mat-label>
      <mat-select class="filter-select" [(value)]="enrollmentType" (selectionChange)="filterApplications()">
        <mat-option value="all-types">All Quote Types</mat-option>
        <mat-option value="oep">OEP</mat-option>
        <mat-option value="sep">SEP</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Sort Order</mat-label>
      <mat-select [(value)]="sortDirection" (selectionChange)="fetchApplications()">
        <mat-option value="desc">Creation Date (Descending)</mat-option>
        <mat-option value="asc">Creation Date (Ascending)</mat-option>
      </mat-select>
    </mat-form-field>
  </div>

</div>

@if (isReadyToDisplay) {
  @for (applicationRecord of applicationRecords; track trackByAppId($index, applicationRecord)) {
    <app-save-quote-card class="card"
      [planNameLabel]="planNameLabel"
      [planMonthlyPremiumLabel]="planMonthlyPremiumLabel"
      [planDeductibleLabel]="planDeductibleLabel"
      [creationDateLabel]="creationDateLabel" 
      [deleteQuoteButtonLabel]="deleteQuoteButtonLabel" 
      [continueApplicationButtonLabel]="continueApplicationButtonLabel"
      [showExpiryNotice]="showExpiryNotice"
      [oepEndDate]="oepEndDate" 
      [lastDayJanuaryEffectiveDate]="lastDayJanuaryEffectiveDate" 
      [quoteType]="quoteType" 
      [disableEmailReferral]="disableEmailReferral"
      [disableReferralTooltip]="disableReferralTooltip"
      [useEmailModal]="useEmailModal"
      [fieldsToDisplay]="fieldsToDisplay"
      [emailFieldLabel]="emailFieldLabel"
      [emailFieldPlaceholder]="emailFieldPlaceholder" 
      [sendEmailButtonLabel]="sendEmailButtonLabel"
      [emailSuccessStatusMessage]="emailSuccessStatusMessage"
      [applicationRecord]="applicationRecord"
      [additionalModalFields]="additionalModalFields"
      (onDeleteQuote)="onDeleteQuote($event)">
    </app-save-quote-card>
  }
} @else {
  <mat-spinner [diameter]="75"></mat-spinner>
}

<!-- Paginator -->
<div class="paginator-container">
  <mat-paginator
    #SavedQuotesPaginator
    [pageSize]="10"
    [pageSizeOptions]="[5, 10, 25, 100]">
  </mat-paginator>
</div>
